import { t } from "@/i18n-js/instance";

export const CUSTOM_TYPE_OPTIONS = [
  {
    label: t("settings.community_bot.knowledge.custom.types.snippet"),
    value: "Snippet",
  },
  {
    label: t("settings.community_bot.knowledge.custom.types.pdf"),
    value: "PDF",
  },
  {
    label: t("settings.community_bot.knowledge.custom.types.txt"),
    value: "TXT",
  },
  {
    label: t("settings.community_bot.knowledge.custom.types.srt"),
    value: "SRT",
  },
];
